<template lang="pug">
  tr.row.row-title
    th.col.check(v-if="!this.spMode")
      label.checkbox
        input(type="checkbox", :checked="checked", :disabled="isGlobalLocked", @click="check")
    th.col(class="company_name")
      span 事業所名
    th.col(class="campany_tel")
      span 電話番号
    th.col(class="progress_state")
      span ステータス
    th.col(class="assigned_to")
      span 担当者
    th.col(class="created_at")
      span リスト追加日時
    th.col(class="updated_at")
      span リスト更新日時
    th.col(class="job_id")
      span 求人ID
    th.col(class="acquisition_date")
      span 掲載開始日
    th.col(class="posting_situation")
      span 掲載状況
    th.col
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: ['checked'],
    computed: {
      ...mapGetters('common', ['isGlobalLocked', 'spMode']),
    },
    methods: {
      check (event) {
        this.$emit('check', { event })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/JobListTableHeader.vue